module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-table', {
    attrs: {
      "show-edit": false,
      "showDelete": false,
      "has-slot": true,
      "has-special-slot": true,
      "table-data": _vm.tableData,
      "table-title": "Archive",
      "fields": _vm.fields,
      "max-items": _vm.tableData.length
    },
    scopedSlots: _vm._u([{
      key: "icons",
      fn: function(row) {
        return _c('span', {
          staticStyle: {
            "width": "150px"
          }
        }, [(!row.item.status || row.item.status.code !== 'PRIMARY') ? _c('a', {
          staticClass: "btn btn-primary",
          attrs: {
            "data-toggle": "tooltip",
            "title": "Compare with Primary Quote"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('compare', row.item)
            }
          }
        }, [_c('em', {
          staticClass: "fa fa-eye"
        })]) : _vm._e()])
      }
    }, {
      key: "specialSlot",
      fn: function(row) {
        return _c('span', {}, [_c('select', {
          staticClass: "form-control",
          attrs: {
            "id": "direction",
            "disabled": row.item.status && row.item.status.code === 'PRIMARY'
          },
          on: {
            "change": function (evt) { return _vm.updateJobStatus(evt, row.item); }
          }
        }, _vm._l((_vm.jobStatuses), function(option) {
          return _c('option', {
            domProps: {
              "value": option.code,
              "selected": option.code === row.item.status.code
            }
          }, [_vm._v(_vm._s(option.name))])
        }), 0), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showCancelReason[row.item.id]),
            expression: "showCancelReason[row.item.id]"
          }]
        }, [_c('div', {
          staticClass: "col-xs-12"
        }, [_c('span', {
          staticClass: "pull-left"
        }, [_vm._v("Enter cancel reason "), _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.cancelReason),
            expression: "cancelReason"
          }],
          staticClass: "pull-left",
          staticStyle: {
            "width": "195px"
          },
          attrs: {
            "cols": "20"
          },
          domProps: {
            "value": (_vm.cancelReason)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.cancelReason = $event.target.value
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12",
          staticStyle: {
            "margin-top": "5px"
          }
        }, [_c('input', {
          staticClass: "btn btn-sm btn-info pull-left",
          attrs: {
            "type": "button",
            "value": "Submit"
          },
          on: {
            "click": function($event) {
              return _vm.enterCancelStatus(row.item)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (row.item.status && row.item.status.code === 'CANCELLED' && row.item.cancelReason),
            expression: "row.item.status && row.item.status.code === 'CANCELLED' && row.item.cancelReason"
          }],
          staticClass: "pull-left"
        }, [_c('div', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_vm._v("Reason: "), _c('mark', [_vm._v(_vm._s(row.item.cancelReason))])])])])
      }
    }, {
      key: "specialSlotHeader",
      fn: function(row) {
        return _c('span', {}, [_c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v("Status")])])
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fbbf6fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Job/JobArchive.vue
// module id = 2223
// module chunks = 1